window.globalHelpersModule.directive 'specimenInfo', ->
  restrict: 'E'
  replace: true
  scope:
    labTest: '='
  templateUrl: 'portal/health-records/specimen-info/specimen-info-directive-template.html'
